import React from "react";
import styled from "styled-components";
import AppHeader from "./AppHeader";
import { MdGavel, MdVerifiedUser, MdWork, MdPhonelinkSetup } from "react-icons/md";

const PageContainer = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 50px;
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 30px auto;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #2d3748;
`;

const Title = styled.h1`
  color: #1a202c;
  font-size: 2rem;
  margin-bottom: 10px;
`;

const IntroText = styled.p`
  color: #4a5568;
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.6;
`;

const GuidelineSection = styled.div`
  margin-bottom: 25px;
  padding: 15px;
  border-radius: 8px;
  background: #fff;
  border-left: 4px solid #1a73e8;
  transition: transform 0.2s;

  &:hover {
    transform: translateX(5px);
    background: #f0f7ff;
  }
`;

const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1a202c;
  margin-top: 0;
  margin-bottom: 10px;
`;

const SectionContent = styled.p`
  margin: 0;
  line-height: 1.6;
  color: #4a5568;
`;

const UserGuideline = () => {
  return (
    <PageContainer>
      <AppHeader />
      <ContentWrapper>
        <Title>User Guidelines (Community Standards)</Title>
        <IntroText>
          To maintain the "Supply Power" of our network, all users must follow these rules:
        </IntroText>

        <GuidelineSection>
          <SectionTitle><MdVerifiedUser color="#1a73e8"/> Authenticity</SectionTitle>
          <SectionContent>
            Business pages must represent real, registered entities. Misrepresentation of skills or business scale is strictly prohibited.
          </SectionContent>
        </GuidelineSection>

        <GuidelineSection>
          <SectionTitle><MdGavel color="#1a73e8"/> Professional Conduct</SectionTitle>
          <SectionContent>
            Messaging and group features are for business growth. Spamming, harassment, or non-business solicitation will lead to account suspension.
          </SectionContent>
        </GuidelineSection>

        <GuidelineSection>
          <SectionTitle><MdWork color="#1a73e8"/> Job Posting Integrity</SectionTitle>
          <SectionContent>
            All job listings must be legitimate. Charging "fees" from job seekers for interviews is a violation of our policy.
          </SectionContent>
        </GuidelineSection>

        <GuidelineSection>
          <SectionTitle><MdPhonelinkSetup color="#1a73e8"/> Content Rights</SectionTitle>
          <SectionContent>
            Users retain ownership of their posts, but grant Avaami Business Connect a license to display and distribute that content within the platform to facilitate B2C/B2B connections.
          </SectionContent>
        </GuidelineSection>

      </ContentWrapper>
    </PageContainer>
  );
};

export default UserGuideline;